import React from 'react';
import TaskButton from './TaskButton';
import { Link } from 'react-router-dom';

class ActionButton extends React.Component {
  render() {
    const task = this.props.task
    if (task.removed === true || task.rejected === true) {
      return null
    } else if (task.complete === true) {
      return (
        <span><TaskButton label='Reject' taskId={this.props.taskId} type='reject' /></span>
      )
    } else {
      return (
        <span><TaskButton label='Complete' taskId={this.props.taskId} type='approve' />
          <TaskButton label='Reject' taskId={this.props.taskId} type='reject' /></span>
      )
    }
  }
}

const TaskList = props => {
  if (!props.tasks) {
    return (
      <div className='broad'>Loading...</div>
    );
  }

  if (props.tasks.length === 0) {
    return (
      <div className='empty'>
        No tasks...
      </div>
    );
  }
  const convertTaskStatus = (task) => {
    if (task.rejected === true) {
      return 'rejected'
    } else if (task.complete === true) {
      return 'completed'
    } else if (task.complete === false) {
      return 'pending'
    }
  }
  return (
    <div>
      <table className="dataTable">
        <thead>

          {(() => {
            switch (props.type) {
              case 'withdraw':
                return (
                  <tr>
                    <th>Key</th>
                    <th>Created</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Amount</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                )
              case 'kyc':
                return (
                  <tr>
                    <th>Key</th>
                    <th>Created</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                )
              case 'bank':
                return (
                  <tr>
                    <th>Key</th>
                    <th>Created</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                )
              case 'deposit':
                return (
                  <tr>
                    <th>Key</th>
                    <th>Created</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                )
              case 'gemini':
                return (
                  <tr>
                    <th>Key</th>
                    <th>Created</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Details</th>
                    <th>Action</th>
                  </tr>
                )
              default:
                return (
                  <tr>
                    <th>Key</th>
                    <th>Created</th>
                    <th>Task</th>
                    <th>User</th>
                    <th>Amount</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                )
            }
          })()}

        </thead>
        <tbody>
          {
            props.tasks.map(task => {
              if (props.type === 'withdraw') {
                let account = task.variable.account
                return (
                  <tr key={task.key}>
                    <td>{task.key}</td>
                    <td>{task.created}</td>
                    <td>{task.action}</td>
                    <td><Link to={`/users/${task.variable.user}`}>User Detail</Link></td>
                    <td>{task.variable.amount}</td>
                    <td className="keyfield">
                      <strong>SWIFT:</strong> {account ? account.swiftCode : ''} <br />
                      <strong>Account Name:</strong> {account ? account.accountName : ''} <br />
                      <strong>Account Number:</strong> {account ? account.accountNumber : ''} <br />
                      <strong>Bank Address:</strong> {account ? account.bankAddress : ''} <br />
                      <strong>Bank Name:</strong> {account ? account.bankName : ''} <br />
                      <strong>Country Code:</strong> {account ? account.countryCode : ''} <br />
                      <strong>Currency Code:</strong> {account ? account.currencyCode : ''} <br />
                    </td>
                    <td>{convertTaskStatus(task)}</td>
                    <td><ActionButton task={task} action={task.action} taskId={task.key} /></td>
                  </tr>
                )
              }
              else if (props.type === 'kyc') {
                return (
                  <tr key={task.key}>
                    <td>{task.key}</td>
                    <td>{task.created}</td>
                    <td>{task.action}</td>
                    <td><Link to={`/users/${task.variable.user}`}>User Detail</Link></td>
                    <td className="keyfield">
                      <strong>Type:</strong> {task.variable.type} <br />
                      <strong>Name:</strong> {task.variable.name} <br />
                      <strong>Number:</strong> {task.variable.number} <br />
                      <strong>Expiry:</strong> {task.variable.expiry} <br />
                      <strong>Address:</strong> {task.variable.address} <br />
                      <strong>Photo:</strong> <a target='_blank' href={task.variable.idLink}>Photo Link</a>
                    </td>
                    <td>{convertTaskStatus(task)}</td>
                    <td>
                      <ActionButton task={task} action={task.action} taskId={task.key} />
                    </td>
                  </tr>
                )
              }
              else if (props.type === 'bank') {
                return (
                  <tr key={task.key}>
                    <td>{task.key}</td>
                    <td>{task.created}</td>
                    <td>{task.action}</td>
                    <td><Link to={`/users/${task.variable.user}`}>User Detail</Link></td>
                    <td className="keyfield">
                      <strong>Amount1:</strong> {task.variable.amount1} <br />
                      <strong>Amount2:</strong> {task.variable.amount2} <br />
                      <strong>Verify Code:</strong> {task.variable.verifyCode} <br />
                      <strong>SWIFT:</strong> {task.variable.swiftCode} <br />
                      <strong>Account Name:</strong> {task.variable.accountName} <br />
                      <strong>Account Number:</strong> {task.variable.accountNumber} <br />
                      <strong>Bank Address:</strong> {task.variable.bankAddress} <br />
                      <strong>Bank Name:</strong> {task.variable.bankName} <br />
                      <strong>Country Code:</strong> {task.variable.countryCode} <br />
                      <strong>Currency Code:</strong> {task.variable.currencyCode} <br />
                    </td>
                    <td>{convertTaskStatus(task)}</td>
                    <td><ActionButton task={task} action={task.action} taskId={task.key} /></td>
                  </tr>
                )
              }
              else if (props.type === 'deposit') {
                return (
                  <tr key={task.key}>
                    <td>{task.key}</td>
                    <td>{task.created}</td>
                    <td>{task.action}</td>
                    <td><Link to={`/users/${task.variable.user_key}`}>User Detail</Link></td>
                    <td className="keyfield">
                      <strong>Bank Reference:</strong> {task.variable.bank_reference} <br />
                      <strong>Amount:</strong> {task.variable.amount} <br />
                      <strong>Transaction key1:</strong> {task.variable.details.transaction_key1} <br />
                      <strong>Transaction key2:</strong> {task.variable.details.transaction_key2} <br />
                    </td>
                    <td>{convertTaskStatus(task)}</td>
                    <td><ActionButton task={task} action={task.action} taskId={task.key} /></td>
                  </tr>
                )
              }
              else if (props.type === 'gemini') {
                return task.removed ? null : (
                  <tr key={task.key}>
                    <td>{task.key}</td>
                    <td>{task.created}</td>
                    <td>{task.action}</td>
                    <td><Link to={`/users/${task.variable.user}`}>{task.variable.user}</Link></td>
                    <td className="keyfield">
                      <strong>Order key:</strong> <Link to={`/trade/detail/${task.variable.order_key}`}>{task.variable.order_key} </Link><br />
                      <strong>Order Status:</strong> {task.variable.order_status} <br />
                      <strong>Order Id:</strong> {task.variable.order_id} <br />
                      <strong>Symbol:</strong> {task.variable.symbol} <br />
                      <strong>Amount:</strong> {task.variable.amount} <br />
                      <strong>Price:</strong> {task.variable.price} <br />
                      <strong>Price discount:</strong> {task.variable.price_discount} <br />
                      <strong>Settle price:</strong> {task.variable.settle_price} <br />
                      <strong>Settle price discount:</strong> {task.variable.settle_price_discount} <br />
                    </td>
                    <td><ActionButton task={task.task} action={task.action} taskId={task.key} /></td>
                  </tr>
                )
              }
              else {
                return (
                  <tr key={task.key}>
                    <td>{task.key}</td>
                    <td>{task.created}</td>
                    <td className="keyfield"><Link to={`/users/${task.key}`}>{task.key}</Link></td>
                    <td>{task.action}</td>
                    <td>{task.variable.amount}</td>
                    <td className="keyfield"><Link to={`/users/${task.variable.user}`}>{task.variable.user}</Link></td>
                    <td>{convertTaskStatus(task)}</td>
                    <td><ActionButton task={task.task} action={task.action} taskId={task.key} /></td>
                  </tr>
                )
              }
            })
          }
        </tbody>
      </table>
    </div>
  );
};

export default TaskList;



// WEBPACK FOOTER //
// ./src/components/widgets/TaskList.js